import { Node, wrappingInputRule, mergeAttributes } from '@tiptap/core';

const formatToPrefix = (format, depth) => {
  switch (format) {
    case "disc":
      return "•";
    case "circle":
      return "◦";
    case "square":
      return "▪";
    default: {
      const formats = [
        "disc",
        "circle",
        "square"
      ];
      return formatToPrefix(formats[depth % formats.length], depth);
    }
  }
};
const calculateDepthAndFormat = (doc, node, pos) => {
  const resolvedPos = doc.resolve(pos);
  const depth = resolvedPos.depth;
  let totalDepth = 0;
  let format = node.attrs.format;
  for (let i = depth; i >= 0; i--) {
    const node2 = resolvedPos.node(i);
    if (node2.type.name === "fbcBulletList") {
      totalDepth++;
      if (node2.attrs.format !== "default" && format === "default") {
        format = node2.attrs.format;
      }
    } else {
      break;
    }
  }
  return {
    totalDepth,
    format
  };
};
const inputRegex = /^\s*([-+*])\s$/;
const FbcBulletList = Node.create({
  priority: 100,
  name: "fbcBulletList",
  content: "paragraph block*",
  group: "block list",
  addAttributes() {
    return {
      format: {
        default: "default",
        parseHTML: (element) => {
          return element.hasAttribute("data-format") ? element.getAttribute("data-format") : "default";
        },
        renderHTML: (attributes) => {
          return {
            "data-format": attributes.format
          };
        }
      }
    };
  },
  parseHTML() {
    return [
      {
        priority: 52,
        tag: "ul",
        skip: true
      },
      {
        tag: "li",
        priority: 52,
        getAttrs: (node) => {
          const closestList = node.closest("ol,ul");
          if (closestList && closestList.tagName === "ul") {
            return {
              ["data-type"]: "fbc-bullet-list"
            };
          }
          return false;
        }
      },
      {
        tag: 'div[data-type="fbc-bullet-list"]'
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "ul",
      mergeAttributes(HTMLAttributes, {
        "data-type": "fbc-bullet-list"
      }),
      [
        "li",
        0
      ]
    ];
  },
  addNodeView() {
    return ({ editor, node, getPos }) => {
      const { dom, contentDOM } = renderFbcBulletList(node, editor.state.doc, getPos());
      return {
        dom,
        contentDOM
      };
    };
  },
  addInputRules() {
    const inputRule = wrappingInputRule({
      find: inputRegex,
      type: this.type,
      keepMarks: true
    });
    return [
      inputRule
    ];
  }
});
const renderFbcBulletList = (node, doc, pos) => {
  const dom = document.createElement("div");
  dom.classList.add("fbc-list");
  dom.dataset.type = "fbc-bullet-list";
  dom.dataset.uuid = node.attrs["data-uuid"];
  dom.dataset.createdAt = node.attrs["data-created-at"];
  const prefix = document.createElement("div");
  prefix.classList.add("fbc-list-prefix");
  prefix.contentEditable = "false";
  prefix.style.height = "calc(1.5em + 4px)";
  const prefixContent = document.createElement("div");
  prefixContent.classList.add("fbc-list-prefix-content");
  const { totalDepth, format } = calculateDepthAndFormat(doc, node, pos);
  const prefixString = formatToPrefix(format, totalDepth);
  prefixContent.style.setProperty("--fbc-list-prefix", `"${prefixString}"`);
  prefixContent.style.setProperty("--fbc-list-prefix-font-size", "1.5em");
  prefixContent.style.setProperty("--fbc-list-prefix-line-height", "1");
  prefixContent.style.setProperty("--fbc-list-prefix-font-family", "Arial");
  prefixContent.contentEditable = "false";
  prefix.appendChild(prefixContent);
  const content = document.createElement("div");
  content.classList.add("fbc-list-content");
  dom.append(prefix, content);
  return {
    dom,
    contentDOM: content
  };
};

export { FbcBulletList as default, inputRegex, renderFbcBulletList };
//# sourceMappingURL=FbcBulletList.js.map
